import { render, staticRenderFns } from "./onlinegoodsbox.vue?vue&type=template&id=7a362a36&scoped=true&"
import script from "./onlinegoodsbox.vue?vue&type=script&lang=js&"
export * from "./onlinegoodsbox.vue?vue&type=script&lang=js&"
import style0 from "./onlinegoodsbox.vue?vue&type=style&index=0&id=7a362a36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a362a36",
  null
  
)

export default component.exports